// extracted by mini-css-extract-plugin
export var cardLayout = "_95-1";
export var paginationContainer = "_95-0";